import Prism from "prismjs";

export function initPrism() {
    Prism.highlightAll()
}